import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DocumentTemplateModel} from "../../entity/documentTemplate.model";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {DocumentTemplatePlaceholderModel} from "../../entity/documentTemplatePlaceholder.model";
import {
  ReportComponentSummaryModel
} from "../../../../../reporting/report-component/api/entity/reportComponentSummary.model";
import {SelectElementV2} from "../../../../../../components/common/select/selectElementV2";
import {UrlParameterBuilder} from "../../../../../core/http/UrlParameterBuilder";
import {Order, Sort} from "../../../../../../shared/utils/url.builder";
import {
  ReportComponentSummarySignatureFindAllService
} from "../../../../../reporting/report-component/impl/service/findPaginated/reportComponentSummarySignatureFindAll.service";
import {InsolesSummaryFindAllService} from "../../../../../insole/insoles/impl/service/insolesSummaryFindAll.service";
import {CardModule} from "../../../../../core/component/card/card.module";
import {CheckboxInputModule} from "../../../../../../components/common/checkbox/checkbox-input/checkbox-input.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {InputTextModule} from "../../../../../core/component/input-text/input-text.module";
import {
  InsolesSelectFilterModule
} from "../../../../../insole/insoles/api/component/insoles-select-filter/insoles-select-filter.module";
import {
  ReportComponentSelectFilterModule
} from "../../../../../reporting/report-component/api/component/report-component-select-filter/report-component-select-filter.module";
import {
  SaleProductSelectComponent
} from "../../../../../sale/modules/product/api/component/sale-product-select/sale-product-select.component";
import {
  UserSelectFilterModule
} from "../../../../../account/modules/user/api/component/user-select-filter/user-select-filter.module";

@Component({
  selector: 'app-document-template-generate-form',
  standalone: true,
  imports: [CommonModule, CardModule, CheckboxInputModule, FormFieldModule, InputTextModule, InsolesSelectFilterModule, ReportComponentSelectFilterModule, SaleProductSelectComponent, UserSelectFilterModule],
  templateUrl: './document-template-generate-form.component.html',
  providers: [
    ReportComponentSummarySignatureFindAllService,
    InsolesSummaryFindAllService,
  ],
  styleUrls: [
      './document-template-generate-form.component.scss'
  ]
})
export class DocumentTemplateGenerateFormComponent implements OnChanges{

  @Input() partnerId: number;
  @Input() documentTemplate: DocumentTemplateModel;
  @Input() inputStepValue: 'DOCUMENT_TEMPLATE_PLACE_HOLDER_INPUT_STEP_AT_EXTERNAL_SIGNATURE' | 'DOCUMENT_TEMPLATE_PLACE_HOLDER_INPUT_STEP_AT_GENERATION' = 'DOCUMENT_TEMPLATE_PLACE_HOLDER_INPUT_STEP_AT_GENERATION';
  @Input() parentFormGroup: FormGroup;


  signatureElements: SelectElementV2<ReportComponentSummaryModel>[] = [];

  constructor(private formBuilder: FormBuilder,
              public signatureService: ReportComponentSummarySignatureFindAllService,
              public insolesService: InsolesSummaryFindAllService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentFormGroup']) {
      if (this.parentFormGroup) {
        this.parentFormGroup.removeControl('placeHolders');
        this.parentFormGroup.removeControl('facts');

        this.parentFormGroup.addControl('facts', this.formBuilder.array([]));
        this.parentFormGroup.addControl('placeHolders', this.formBuilder.array([]));
      }
    }
    if (changes['documentTemplate']) {
      this.parentFormGroup?.patchValue({
        facts: [],
        placeHolders: []
      });
      if (this.documentTemplate) {
        const businessContexts: LovValueSummary[] =[];
        const loadSignature = this.atLeastOnPlaceHolderWithText(this.documentTemplate.placeHolders, 'signature');
        let loadInsoles = false;
        console.log('Hello', this.documentTemplate, this.documentTemplate.placeHolders
            .filter(value => value.inputStep?.value === this.inputStepValue)
        );
        this.documentTemplate.placeHolders
            .filter(value => value.inputStep?.value === this.inputStepValue)
            .filter(value => value.text !== 'signatureExterne')
            .forEach(value => {
              if (value.contentSubstitution) {
                const businessContext = value.contentSubstitution?.businessContext;
                if (businessContext) {
                  if (businessContexts.findIndex(value1 => value1.value == businessContext.value) < 0) {
                    if (value.contentSubstitution.businessContextLabel) {
                      businessContext.label = value.contentSubstitution.businessContextLabel;
                    }
                    businessContexts.push(businessContext)
                  }
                  if (businessContext.value === 'BUSINESS_CONTEXT_INSOLES') {
                    loadInsoles = true;
                  }
                }
              } else {
                const valueControl = this.formBuilder.control(undefined, Validators.required);
                this.placeHolderArray.push(this.formBuilder.group({
                  label: this.formBuilder.control(value.label?.replace('.', ' ')),
                  text: this.formBuilder.control(value.text),
                  value: valueControl,
                  typeValue: this.formBuilder.control(value.type?.value),
                  mandatory: this.formBuilder.control(value.mandatory)
                }));
                if (value.mandatory) {
                  valueControl.addValidators(Validators.required);
                }
              }
            });
        if (loadSignature) {
          this.loadSignatures();
        }
        if (loadInsoles) {
          this.loadInsoles();
        }

        businessContexts.forEach(value => {
          if ((value.value !== 'BUSINESS_CONTEXT_PARTNER')
              || !this.partnerId) {
            this.factsArray.push(this.formBuilder.group({
              label: this.formBuilder.control(value.label),
              businessContext: this.formBuilder.control(value.value),
              value: this.formBuilder.control(undefined),
            }));
          }
        })
      }
    }
  }

  atLeastOnPlaceHolderWithText(placeHolders: DocumentTemplatePlaceholderModel[], text: string) {
    return placeHolders.findIndex(value => value.text === text) > -1;
  }

  loadSignatures() {
    this.signatureService.refresh()
        .then((results: ReportComponentSummaryModel[]) => {
          this.signatureElements = [];
          if (results?.length > 0) {
            this.signatureElements = results.map(value => new SelectElementV2<ReportComponentSummaryModel>(value.id,  value.label, value));
          }
        });
  }

  loadInsoles() {
    if (this.partnerId) {
      this.insolesService.parameters = new UrlParameterBuilder()
          .addParameter('patient.id', this.partnerId)
          .addParameter('view', 'CUSTOMER')
          .parameters;
      this.insolesService.sort = new Sort('businessId', Order.DESCENDING);
      this.insolesService.refresh();
    }
  }



  get placeHolderArray(): FormArray {
    return this.parentFormGroup.get('placeHolders') as FormArray;
  }
  get factsArray(): FormArray {
    return this.parentFormGroup.get('facts') as FormArray;
  }

}
